import palette from "src/theme/palette";

export const RENEWAL_WARNING_CHIP_STYLE = {
  backgroundColorPath: ["warning", "200"],
  textColorPath: ["warning", "700"]
};

export const RENEWAL_WARNING_DAYS_THRESHOLD = 30;

export const TEAM_ROLES = {
  ownerName: "Customer Success Manager",
  solutionArchitect: "Solutions Architect"
};

export const PRODUCTS_TABLE_COLUMNS = [
  { field: "name", headerName: "Product" }
];

export const USAGE_BAR_COLORS = {
  over: palette.warning[500],
  under: palette.secondary[500],
  track: palette.system[300]
};
